const paths = {
  campaigns: '/campaigns',
  profile: '/profile',
  customers: '/customers',
  recipients: '/recipients',
  setpassword: '/setpassword',
  users: '/users',
};

export default paths;